import { render } from 'preact';
import { App } from './App';
import './styles/global.css';

const root = document.getElementById('app');
if (root) {
  render(<App />, root);
}

// Register the app-shell service worker in production builds only — dev
// mode's own HMR/module graph makes an installed SW actively counterproductive
// (stale-cached modules), and the worker's job (offline app shell, never
// caching /api/) only matters once the app is actually deployed.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
